'use client';

import { useTranslation } from '@/lib/i18n';
import { cn } from '@/lib/utils';
import { Skeleton } from '@mui/material';
import Image from 'next/image';
import { ReactNode } from 'react';

const HTML_LINE_BREAK_PATTERN = /<br\s*\/?>/gi;
const SKELETON_LINES = [0, 1, 2];

interface PythraSummaryProps {
  title?: string;
  summary?: string | null;
  className?: string;
  loading?: boolean;
}
export default function PythraSummary({
  summary,
  className,
  loading,
  title = 'Pythra Summary',
}: PythraSummaryProps) {
  const { t } = useTranslation();
  const normalizedSummary = summary?.replace(HTML_LINE_BREAK_PATTERN, '\n').trim();

  if (!loading && !normalizedSummary) return null;

  return (
    <div
      className={cn(
        'border border-[rgba(255,255,255,.08)] rounded-xl overflow-hidden relative',
        className,
      )}
      style={{
        background:
          'linear-gradient(101.67deg, rgba(32, 24, 65, 1) 3.82%, rgba(41, 18, 41, 1) 97.83%)',
      }}
    >
      <Image
        src="/image/icon_ai.png"
        width={50}
        height={50}
        alt=""
        className="absolute right-8 top-8 opacity-60 sm:right-25"
      />

      <div
        className="p-4 relative z-10"
        style={{
          background:
            'linear-gradient(101.67deg, rgba(32, 24, 65, .7) 3.82%, rgba(41, 18, 41, .7) 97.83%)',
        }}
      >
        <div className="flex items-center gap-2 mb-5 ">
          <Image src="/image/icon_ai.png" width={12} height={12} alt="" />
          <span className="font-semibold text-lg">{t(title)}</span>
        </div>
        {loading ? (
          <div className="flex flex-col gap-2">
            {SKELETON_LINES.map((line) => (
              <Skeleton key={line} variant="text" sx={{ fontSize: '1rem', bgcolor: 'grey.800' }} />
            ))}
          </div>
        ) : (
          <div className="whitespace-pre-line wrap-break-word text-base text-white/90">
            {normalizedSummary}
          </div>
        )}
      </div>
    </div>
  );
}
